import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import PopupLayout from "../site/popup-layout";
import UserTopUpTable from "./top-up";

import AwrabetManagerTopupPopup from "../../../awrabet/desktop-components/user/manager-topup-popup";

export default class ManagerTopupPopup extends AwrabetManagerTopupPopup {
    render() {
        return (
            <PopupLayout>
                <div class="px-0 py-3 bg-white border text-gray-900">
                    <div class="py-2 text-lg text-center"><Trans>Giroconto</Trans></div>
                    <UserTopUpTable
                        iduser={this.props.id}
                        isaffiliate={this.props.type === 'affiliate'}
                    />
                </div>
            </PopupLayout>
        );
    }
}

// deprecated
export const TopupPopup = (id: string, isaffiliate: boolean = false) => {
    window.open(
        '/admin/topup/' + (isaffiliate ? 'affiliate' : 'player') + '/' + id,
        'affilateTransactionsWindow',
        'width=960,height=600,scrollbars=yes'
    );
}

export interface TopupUser {
    id: string,
    affiliate?: boolean,
    shop?: boolean,
    parent?: string
}
export const openTopupPopup = (user: TopupUser) => {
    let urlParams = {type: null, id: null}
    if (user.affiliate) {
        urlParams = {type: 'affiliate', id: user.id}
    } else if (user.shop) {
        urlParams = {type: 'affiliate', id: user.parent}
    } else {
        urlParams = {type: 'player', id: user.id}
    }
    window.open(
        '/admin/topup/' + urlParams.type + '/' + urlParams.id,
        'affilateTransactionsWindow',
        'width=960,height=600,scrollbars=yes'
    );
}
